module.exports = __webpack_public_path__ + "static/media/Restaurant.0b6f8481.svg";